import { render, staticRenderFns } from "./CompswitchBox.vue?vue&type=template&id=344e9316&scoped=true"
import script from "./CompswitchBox.vue?vue&type=script&lang=js"
export * from "./CompswitchBox.vue?vue&type=script&lang=js"
import style0 from "./CompswitchBox.vue?vue&type=style&index=0&id=344e9316&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344e9316",
  null
  
)

export default component.exports